import React, {useContext, useEffect, useState} from 'react';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';
import {Route, Switch, useLocation} from 'react-router-dom';
import {ProgramsMenu} from '../Programs/ProgramsMenu'
// import {ProgramsTeams} from '../Programs/ProgramsTeams'
// import {ProgramsEmployees} from '../Programs/ProgramsEmployees'
// import {ProgramsPerkPrograms} from '../Programs/ProgramsPerkPrograms'
// import {ProgramsExpensePrograms} from '../Programs/ProgramsExpensePrograms'
import {PerksPage} from '../pages/PerksPage'
// import {PerksProgramManagement} from './PerksProgramMangement';
import {AddPerksToProgramPage} from './AddPerksToProgramPage'
import {ExpensesPage} from '../pages/ExpensesPage'
import {AddExpensesToProgramPage} from '../Expenses/AddExpensesToProgramPage'
import {EmployeeDetails} from '../Employees/EmployeeDetails'
import {TeamsPage} from '../pages/TeamsPage'
import {TeamDetails} from '../Teams/TeamDetails'
import {EmployeesPage} from '../pages/EmployeesPage'
import {AppContext} from '../../context/app/appContext';
import {TeamsPageTrial} from '../pages/TeamsPageTrial';
import {EmployeesPageTrial} from '../pages/EmployeesPageTrial';

export const ProgramsPage = (props) => {
    console.log("hereeeeeeeeeeeee")
    let location = useLocation();
    console.log(location.pathname);

    const [subscription, setSubscription] = useState(null);
    const appContext = useContext(AppContext);

    useEffect(() => {
        if(appContext.organization.subscription !== undefined){
            setSubscription(appContext.organization.subscription)
        }
    }, [])

    useEffect(() => {
        if(appContext.organization.subscription !== undefined){
            setSubscription(appContext.organization.subscription)
        }
    }, [appContext.organization.subscription])

    return (
        <div id="app">
            <div id="content" style={{display: 'flex', height: '100vh'}}>
                <span style={{width: '10vw', height: '100%'}}>
                    <Sidebar />
                </span>
                <span style={{width: '90vw', height: '100vh'}}>
                    <div style={{width: '100%', height: '10vh'}}>
                        <TopBar />
                    </div>
                    <div style={{width: '90vw', height: '91.5vh', overflowY: 'scroll', overflowX: 'visible'}}>
                        <ProgramsMenu />
                        <div>
                            {subscription && (subscription === 'free-trial' ?
                                <Switch>
                                    <Route exact path='/programs/teams/:id'><TeamDetails/></Route>
                                    <Route exact path="/programs/employees/:id"><EmployeeDetails/></Route>
                                    <Route exact path="/programs/employees"><EmployeesPageTrial/></Route>
                                    <Route exact path="/programs/perk-programs/:id/add-perks"><AddPerksToProgramPage /></Route>
                                    <Route exact path="/programs/perk-programs/active"><PerksPage /></Route>
                                    <Route exact path="/programs/perk-programs/expired"><PerksPage /></Route>
                                    <Route exact path="/programs/perk-programs"><PerksPage /></Route>
                                    <Route exact path="/programs/expense-programs/:id/add-expenses"><AddExpensesToProgramPage /></Route>
                                    <Route exact path="/programs/expense-programs/active"><ExpensesPage /></Route>
                                    <Route exact path="/programs/expense-programs/expired"><ExpensesPage /></Route>
                                    <Route exact path="/programs/expense-programs"><ExpensesPage /></Route>
                                    <Route exact path="/programs"><TeamsPageTrial/></Route>
                                </Switch>
                            :
                                <Switch>
                                    <Route exact path='/programs/teams/:id'><TeamDetails/></Route>
                                    <Route exact path="/programs/employees/:id"><EmployeeDetails/></Route>
                                    <Route exact path="/programs/employees"><EmployeesPage/></Route>
                                    <Route exact path="/programs/perk-programs/:id/add-perks"><AddPerksToProgramPage /></Route>
                                    <Route exact path="/programs/perk-programs/active"><PerksPage /></Route>
                                    <Route exact path="/programs/perk-programs/expired"><PerksPage /></Route>
                                    <Route exact path="/programs/perk-programs"><PerksPage /></Route>
                                    <Route exact path="/programs/expense-programs/:id/add-expenses"><AddExpensesToProgramPage /></Route>
                                    <Route exact path="/programs/expense-programs/active"><ExpensesPage /></Route>
                                    <Route exact path="/programs/expense-programs/expired"><ExpensesPage /></Route>
                                    <Route exact path="/programs/expense-programs"><ExpensesPage /></Route>
                                    <Route exact path="/programs"><TeamsPage/></Route>
                                </Switch>
                            )}
                            
                        </div>
                    </div>
                </span>
            </div>
        </div>
    );
};